import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function Loader({ onDone }) {
  const [count, setCount] = useState(0);
  const [gone, setGone] = useState(false);

  useEffect(() => {
    let raf;
    let start;
    const dur = 2200;
    const tick = (t) => {
      if (!start) start = t;
      const p = Math.min((t - start) / dur, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setCount(Math.round(eased * 100));
      if (p < 1) {
        raf = requestAnimationFrame(tick);
      } else {
        setTimeout(() => {
          setGone(true);
          setTimeout(() => onDone && onDone(), 900);
        }, 350);
      }
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [onDone]);

  return (
    <AnimatePresence>
      {!gone && (
        <motion.div
          className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-[#0a0a0b]"
          exit={{ y: "-100%" }}
          transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
        >
          <motion.p
            className="font-display text-sm uppercase tracking-[0.35em] text-[#8a8a86]"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2 }}
          >
            Entering the Lemoncaps universe…
          </motion.p>
          <div className="mt-8 overflow-hidden">
            <motion.span
              className="font-display block text-[16vw] font-bold leading-none text-[#f4f4f0] md:text-[10vw]"
              key={Math.floor(count / 1)}
            >
              {count}
            </motion.span>
          </div>
          <div className="mt-6 h-[2px] w-[60vw] max-w-md overflow-hidden bg-white/10">
            <div
              className="h-full bg-[#d4ff4e] transition-[width] duration-100"
              style={{ width: `${count}%` }}
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
